import { render, staticRenderFns } from "./ProductTextLanguagesDialog.vue?vue&type=template&id=7a0cf772&scoped=true&lang=pug&"
import script from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTextLanguagesDialog.vue?vue&type=style&index=0&id=7a0cf772&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cf772",
  null
  
)

export default component.exports